module.exports = Em.Component.extend({
    layoutName: 'components/coupon-offer-bar',

    classNames: ['top-bar', 'top-bar-blue'],

    organization: null,

    couponOffer: null
})
